module.exports = __webpack_public_path__ + "static/media/32.8e0d539a.jpeg";